export interface PendingTask {
    taskId: string;
    taskType: string;
    payload?: any
}

export interface UnreadTask {
    taskId: string;
    taskType: string;
    status: 'success' | 'failed';
    errorMessage?: string;
    payload?: any;
    result?: {
        pointsType?: string;
        rewardAmount?: number;
        currentFlowingWater?: number;
    };
}

export enum PendingTaskType {
    GIFT_CODE_REDEEM = 'gift_code_redeem',
    MEMBERSHIP_EXPIRY_CHECK = 'membership_expiry_check',
    ACTIVITY_REWARD_CLAIM = 'activity_reward_claim',
    DAILY_LOGIN_REWARD = 'daily_login_reward',
    MEMBER_MONTHLY_DROPS_GRANT = 'member_monthly_drops_grant',
    INVITE_REWARD_GRANT = 'invite_reward_grant',
    CLAIM_FOLLOW_REWARD = 'claim_follow_reward',
    MEMBERSHIP_RENEWAL_ACTIVATE = 'membership_renewal_activate'
}

export interface memberState {
    memberInfo: memberInfoProps | null,
    imagePricingRules: ImagePricingRule[],
    GuestMode: GuestMode,
    openDropDialog: boolean,
    openMembershipPurchaseDialog: boolean,
    openYearMemberDialog: boolean,
    openMemberBillDialog: boolean,
    openWaterShortage: boolean,
    openWaterShortage2: boolean,
    globalDialogTips: globalDialogTipsProps | null
    notifyDialogTips: boolean
    notifyUnreadCount: number,
    dropActiveDialogOpen: boolean,
    surveyDialogOpen: boolean,
    pendingLoginData: any,
    pendingTasks: PendingTask[],
    unreadTasks: UnreadTask[]
}

export interface globalDialogTipsProps {
    type: "waring" | "error" | "success" | "default",
    content: string,
    buttonContent: string,
    title: string,
    cancelFun?: () => void;
    confirmFun?: () => void;
}

export interface memberInfoProps {
    userId: string,
    email: string,
    membershipTier: 'free' | 'plus' | 'pro' | 'max' | 'plus_year' | 'pro_year' | 'max_year' ,
    flowingWater: number,
    memberDrops: number,
    otherDrops: number,
    supplyDrop: number,
    supplyDropsExpiresAt?: string,
    createAt: number,
    registerDays: number,
    isBuyLimitDay: boolean,
    isGetWelcomePoint: boolean,
    isCloudauthIdentity: boolean,
    renewalQueueMonths: number,
    supplyDropsExpiresAtTimeStamp?: number | null,
    memberDropsExpiresAtTimeStamp?: number | null,
    currentMemberEndTime: number | null,
    activities : activitiesProps[],
}

export interface activitiesProps {
    activityId: string,
    name: string,
    description: string,
    rewardAmount: number,
    rewardDropsType: string,
    taskType: string,
    claimMethod: string,
    completionCondition: string,
    redirectLink: string,
    refreshMethod: string,
    hasNotification: boolean,
    expired?: boolean,
    status: "pending" | "claimable" | "claimed"
}

export interface ImagePricingRule {
    model_id: string;
    name: string;
    resolutions?: Record<string, {
        supported?: boolean;
        cost?: Array<{ cost: number; effective_at: string }>;
        cost_tier?: Array<{ cost: Partial<Record<'free' | 'plus' | 'plus_year' | 'pro' | 'pro_year' | 'max' | 'max_year', number>>; effective_at: string }>;
    }> | null;
    qualitys?: Record<string, {
        supported?: boolean;
        resolutions?: Record<string, {
            supported?: boolean;
            cost?: Array<{ cost: number; effective_at: string }>;
            cost_tier?: Array<{ cost: Partial<Record<'free' | 'plus' | 'plus_year' | 'pro' | 'pro_year' | 'max' | 'max_year', number>>; effective_at: string }>;
        }>;
    }> | null;
}

export interface ProductProps {
    id: number;
    identifier: string;
    name: string;
    description: string;
    price: number;
    points_amount: number;
    is_active: number;
    created_at: string;
    updated_at: string;
    discount?: string;
    priority?: number;
    original_price?: number;
    is_timed_product?: number
    dingshi_type?: string
}

export interface ProductPaginationProps {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
}

export interface ProductInfoProps {
    pagination: ProductPaginationProps;
    products: ProductProps[];
}

export type GuestMode =
    | 'visitor'     // 游客
    | 'guest'      // 访客
    | 'collaborator'  // 协作者
    | 'owner';  // 画板所有者

export interface GuestPermissions {
    canView: boolean;           // 可以查看画板
    canComment: boolean;        // 可以添加评论
    canEdit: boolean;           // 可以编辑内容
    canCreateShapes: boolean;   // 可以创建新形状
    canDeleteShapes: boolean;   // 可以删除形状
    canEditShapes: boolean;     // 可以编辑现有形状
    canMoveShapes: boolean;     // 可以移动形状
    canResizeShapes: boolean;   // 可以调整形状大小
    canChangeStyles: boolean;   // 可以更改样式
    canExport: boolean;         // 可以导出画板
    canShare: boolean;          // 可以分享画板
}